import { Box } from "@mui/material"
import { Summary } from "routes/schedule/components/summary"
import uniqolor from "uniqolor"
import { formatTime } from "lib/format-time"

export function SkillSummary({ item, results, totalMinutes }) {
    return (
        <Box width={"15vw"} pb={2} minWidth={160} overflow="hidden">
            <Summary
                title={item}
                percent={(100 * (results[item]?.minutes ?? 0)) / totalMinutes}
                color={uniqolor(item).color}
                icon={"ant-design:tool-filled"}
                total={results[item]?.count ?? 0}
                time={formatTime(results[item]?.minutes ?? 0)}
            />
        </Box>
    )
}
